import React, { Component, Fragment } from "react";
import packageJson from "../../../../package.json";
global.appVersion = packageJson.version;

const semverGreaterThan = (versionA, versionB) => {
	const versionsA = versionA.split(/\./g);

	const versionsB = versionB.split(/\./g);
	while (versionsA.length || versionsB.length) {
		const a = Number(versionsA.shift());

		const b = Number(versionsB.shift());
		// eslint-disable-next-line no-continue
		if (a === b) continue;
		// eslint-disable-next-line no-restricted-globals
		return a > b || isNaN(b);
	}
	return false;
};

export default class CacheBuster extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			isLatestVersion: false,
			refreshCacheAndReload: () => {
				console.log("Clearing cache and hard reloading...");
				if (typeof caches !== "undefined") {
					// Service worker cache should be cleared with caches.delete()
					caches.keys().then(function(names) {
						for (let name of names) caches.delete(name);
					});
				}
				// delete browser cache and hard reload
				window.location.reload(true);
			}
		};
	}

	componentDidMount() {
		fetch("/meta.json")
			.then(response => response.json())
			.then(meta => {
				const latestVersion = meta.version;
				const currentVersion = global.appVersion;
				const reloadGuardKey = "cacheBusterReloadedVersion";
				const alreadyReloadedForVersion =
					typeof window !== "undefined" &&
					window.sessionStorage &&
					window.sessionStorage.getItem(reloadGuardKey) === latestVersion;

				const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);
				if (shouldForceRefresh) {
					if (alreadyReloadedForVersion) {
						console.warn(
							`CacheBuster reload already attempted for version ${latestVersion}; skipping to avoid loop.`
						);
						this.setState({ loading: false, isLatestVersion: true });
						return;
					}
					console.log(`We have a new version - ${latestVersion}. Should force refresh`);
					if (typeof window !== "undefined" && window.sessionStorage) {
						window.sessionStorage.setItem(reloadGuardKey, latestVersion);
					}
					this.setState({ loading: false, isLatestVersion: false });
					this.state.refreshCacheAndReload();
				} else {
					console.log(
						`You already have the latest version - ${latestVersion}. No cache refresh needed.`
					);
					if (typeof window !== "undefined" && window.sessionStorage) {
						window.sessionStorage.removeItem(reloadGuardKey);
					}
					this.setState({ loading: false, isLatestVersion: true });
				}
			})
			.catch(err => {
				console.warn('CacheBuster: failed to fetch /meta.json, skipping version check', err);
				this.setState({ loading: false, isLatestVersion: true });
			});
	}

	render() {
		const { loading, isLatestVersion, refreshCacheAndReload } = this.state;
		return this.props.children({ loading, isLatestVersion, refreshCacheAndReload });
	}
}
